import {UserData} from './user-data';

export class User {
  constructor(
    public userName?: string,
    public password?: string,
    public userData?: UserData) {}
}
